import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { ClientLpTranslator } from '../clientLp.translator';
import { ClientLpAction } from '../clientLp.action';

type IDependencies = IClientApiDependencySegment;

export const updateClientLpEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(ClientLpAction.update.started),
  mergeMap((clientLp) => {
    const apiPayload = ClientLpTranslator.toApi(clientLp);
    return dependencies.api.updateLp(apiPayload).pipe(
      mergeMap(() => {
        return [
          ClientLpAction.update.done({ params: clientLp }),
        ];
      }),
      catchApiError((error) => {
        return [
          ClientLpAction.update.failed({ params: clientLp, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
